import { ScratchCampaign } from './types'

export function initScratchCampaign(): ScratchCampaign {
  return {};
};
